const DEFAULT_POLL_INTERVAL = 500;
const DEFAULT_POLL_TIMEOUT = 30000;

const pollRec = (
  action,
  condition,
  { interval, timeout, swallowErrors },
  startTime,
  resolve,
  reject,
  timeoutRef = {}
) => {
  if (Date.now() > startTime + timeout) {
    reject(new Error('polling timed out'));
  } else {
    const pollAgain = () => {
      timeoutRef.current = setTimeout(
        () => pollRec(action, condition, { interval, timeout, swallowErrors }, startTime, resolve, reject, timeoutRef),
        interval
      );
    };

    Promise.resolve(action())
      .then((response) => {
        if (condition(response)) {
          resolve(response);
        } else {
          pollAgain();
        }
      })
      .catch((error) => {
        if (!swallowErrors) {
          reject(error);
        } else {
          pollAgain();
        }
      });
  }
};

const compositeCondition = (conditions) => {
  let conditionStates = conditions.map(() => false);

  return (response) => {
    conditionStates = conditionStates.map((state, index) =>
      state || conditions[index](response)
    );
    return conditionStates.every(state => state === true);
  };
};

export const poll = (
  action,
  conditions,
  {
    interval = DEFAULT_POLL_INTERVAL,
    timeout = DEFAULT_POLL_TIMEOUT,
    delay = 0,
    swallowErrors = false
  } = {}
) => {
  const timeoutRef = {};

  const promise = new Promise((resolve, reject) => {
    const condition = Array.isArray(conditions)
      ? compositeCondition(conditions)
      : conditions;

    const startPoll = () => {
      pollRec(action, condition, { interval, timeout, swallowErrors }, Date.now(), resolve, reject, timeoutRef);
    };

    if (delay > 0) {
      timeoutRef.current = setTimeout(startPoll, delay);
    } else {
      startPoll();
    }
  });

  const halt = () => {
    clearTimeout(timeoutRef.current);
  };

  return { promise, halt };
};



